import { FeatureToggleClientService } from 'feature-toggle-client';
const isBlipConversationsInsightsEnabled = 'is-blip-conversations-insights-enabled';
export class BlipConversationsInsightsFeatures {
    static async IsBlipConversationsInsightsEnabled(studioService) {
        const planStatus = await studioService.getPlanStatusByTenant();
        return planStatus?.hasActivePaidPlan || FeatureToggleClientService.getInstance().isFeatureEnabled(isBlipConversationsInsightsEnabled, false);
    }
}
